//////////////////
// Cookie Notice Controller
//////////////////
App.CookieNotice = (function() {

	var notice, closeButton;
	var selectors = {
		notice: ".cookie-notice",
		closeButton: ".close.btn-primary"
	};
	var flags = {
		COOKIE_NAME: "cookieSeen",
		COOKIE_STATUS: "shown"
	};

	/*
	Render single sidemenu in the page
	*/
	function init() {
		try {
			notice = $(selectors.notice);
			closeButton = notice.find(selectors.closeButton);
			render();
		} catch(e) {
			console.log("Error locating " + selectors.notice, e);
		}
	}

	function render() {

		// Show cookies notice if cookie not set
		if (localStorage.getItem(flags.COOKIE_NAME) != flags.COOKIE_STATUS) {
		  gsap.to(notice, { bottom: 0 , duration: 2, delay: 1 });

			// Enable button and track cookie set
			closeButton.on("click", function() {
				localStorage.setItem(flags.COOKIE_NAME, flags.COOKIE_STATUS);
			  gsap.to(notice, { bottom: -(notice.outerHeight()), display: "none" , duration: .5, delay: .5 });
				return(false);
			})
		} else {
			// If not needed, strip from the DOM
			notice.remove();
		}
	}

	App.register(function() {
		App.log("Registered: App.CookieNotice");
		init();
	});

})();
